const fields = ["surveyId","eventName","residentArea","postcodePrefix","ageGroup","connectionRating","localIssues","localIssuesOther","wantedActivities","wantedActivitiesOther","wantedServices","wantedServicesOther","oneChange","heardOfUUN","volunteerInterest","submittedAt","foodTokenCode","tokenClaimed"];
const cell = (value) => `"${String(Array.isArray(value) ? value.join("; ") : value ?? "").replace(/"/g, '""')}"`;
export function responsesToCsv(rows) { return [fields.join(","), ...rows.map((row) => fields.map((key) => cell(key === "submittedAt" && row[key]?.toDate ? row[key].toDate().toISOString() : row[key])).join(","))].join("\r\n"); }

const anonymousAiFields = [
  "surveyId", "surveyVersion", "submittedAt", "workshopInterest", "topics",
  "priorityTopic", "digitalConfidence", "aiExperience", "motivations",
  "deliveryPreference", "preferredTimes", "barriers", "deviceAccess", "area",
  "riversideResident", "ageGroup", "youthInterest", "contactPermission",
  "referralSource", "isTest",
];

const fullAiFields = [
  "responseId", ...anonymousAiFields, "topicsOther", "motivationsOther",
  "barriersOther", "contactName", "contactEmail", "contactMobile",
  "preferredContactMethod", "contactConsent", "finalComments",
  "referralSourceOther",
];

function csvDate(value) {
  if (value?.toDate) return value.toDate().toISOString();
  if (typeof value?.seconds === "number") return new Date(value.seconds * 1000).toISOString();
  return value;
}

function aiValue(row, key) {
  if (key === "responseId") return row.id;
  if (key === "submittedAt") return csvDate(row.submittedAt);
  if (key === "contactName") return row.contactDetails?.name;
  if (key === "contactEmail") return row.contactDetails?.email;
  if (key === "contactMobile") return row.contactDetails?.mobile;
  if (key === "preferredContactMethod") return row.contactDetails?.preferredMethod;
  if (key === "contactConsent") return row.contactDetails?.consent;
  return row[key];
}

export function aiSurveyResponsesToCsv(rows, { includeContact = false } = {}) {
  const selectedFields = includeContact ? fullAiFields : anonymousAiFields;
  return [
    selectedFields.join(","),
    ...rows.map((row) => selectedFields.map((key) => cell(aiValue(row, key))).join(",")),
  ].join("\r\n");
}
